<div class="py-2">
  <div class="d-flex">
    <div class="d-flex col-6 align-items-center">
      <span class="generator-title me-2">{{ label | localize }}</span>
      <app-field-info
        *ngIf="description"
        class="me-2"
        [testId]="testId + '-description-icon'"
        [infoText]="description"
      ></app-field-info>
      <span *ngIf="value"
            [attr.data-testId]="testId + '-badge'"
            class="badge rounded-pill generator-badge ms-auto me-2 bg-secondary"
      >{{ value }}</span>
    </div>
    <app-generator-text-field
      class="col-6"
      [testId]="testId"
      [text]="text"
      (onTextChange)="onGeneratedTextEdited($event)"
    ></app-generator-text-field>
  </div>
</div>
